import { render, staticRenderFns } from "./RuleManagement.vue?vue&type=template&id=2b8f489e&"
import script from "./RuleManagement.js?vue&type=script&lang=js&"
export * from "./RuleManagement.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports